(function() {
    'use strict';

    let currentForm = null;
    let successHandled = false; // Flag per evitare chiamate multiple
    let formData = {}; // Oggetto per salvare i valori dei campi

    // Funzione per processare gli input del form
    function processFormInputs() {
        // Form wholesale
        currentForm = document.querySelector('form.samitaWS-container');
        
        // Seleziona tutti gli input nei form
        const inputs = document.querySelectorAll('form.samitaWS-container input');

        // Add class form-iub
        if (currentForm) {
            currentForm.classList.add('form-iub-custom');
            
            // Trova e aggiungi event listener al button submit
            const submitButton = currentForm.querySelector('button.submit, input[type="submit"].submit');
            if (submitButton) {
                submitButton.addEventListener('click', function(event) {
                    console.log('🔘 Click su button submit rilevato');

                    // Salva i dati immediatamente al click
                    saveFormData();
                    
                    // Controlla che email e almeno una preference siano valorizzate
                    if (validateIubendaData()) {
                        // Invia subito i dati a Iubenda
                        handleSuccessActions();
                    } else {
                        console.warn('⚠️ Dati insufficienti per Iubenda - skip invio');
                    }
                });
            }
        }
        
        inputs.forEach(function(input) {
            const name = input.getAttribute('name');
            
            if (!name) return;
            
            // Controlli per data-cons-preference
            if (name.includes('acceptTerms[]')) {
                input.setAttribute('data-cons-preference', 'privacy_policy_a');
            } else if (name.includes('acceptTerms-3[]')) {
                input.setAttribute('data-cons-preference', 'privacy_policy_b');
            } else if (name.includes('acceptTerms-5[]')) {
                input.setAttribute('data-cons-preference', 'privacy_policy_c');
            }
            
            // Controlli per data-cons-subject
            if (name === 'email') {
                input.setAttribute('data-cons-subject', 'email');
            } else if (name.includes('text-2')) {
                input.setAttribute('data-cons-subject', 'last_name');
            } else if (name.includes('text') && !name.includes('text-3')) {
                input.setAttribute('data-cons-subject', 'first_name');
            }
        });

        // Reset del flag quando viene processato un nuovo form
        successHandled = false;
        formData = {}; // Reset dei dati salvati

        // Avvia il controllo per il messaggio di successo
        observeSuccessMessage();
    }

    // Funzione per salvare i dati del form prima del submit
    function saveFormData() {
        if (!currentForm) return;
        
        console.log('🔄 Salvando dati del form...');
        
        // Salva solo i campi con attributi data-cons-preference o data-cons-subject
        const relevantInputs = currentForm.querySelectorAll('[data-cons-preference], [data-cons-subject]');
        
        formData = {};
        
        relevantInputs.forEach(function(input) {
            const name = input.getAttribute('name');
            const value = input.type === 'checkbox' || input.type === 'radio' ? input.checked : input.value;
            const consPreference = input.getAttribute('data-cons-preference');
            const consSubject = input.getAttribute('data-cons-subject');
            
            // Debug log
            console.log('📝 Campo trovato:', {
                name: name,
                value: value,
                type: input.type,
                consPreference: consPreference,
                consSubject: consSubject
            });
            
            formData[name] = {
                value: value,
                name: name,
                type: input.type,
                consPreference: consPreference,
                consSubject: consSubject
            };
        });
        
        console.log('💾 Dati form salvati:', formData);
    }

    // Funzione per validare che ci siano email e almeno una preference
    function validateIubendaData() {
        let hasEmail = false;
        let hasPreference = false;
        
        Object.keys(formData).forEach(function(key) {
            const field = formData[key];
            
            // Controlla se c'è un campo email valorizzato
            if (field.consSubject === 'email' && field.value && field.value.trim() !== '') {
                hasEmail = true;
            }
            
            // Controlla se c'è almeno una preference accettata
            if (field.consPreference && field.value === true) {
                hasPreference = true;
            }
        });
        
        console.log('🔍 Validazione Iubenda:', {
            hasEmail: hasEmail,
            hasPreference: hasPreference,
            isValid: hasEmail && hasPreference
        });
        
        if (!hasEmail) {
            console.error('❌ Email non trovata o vuota');
        }
        
        if (!hasPreference) {
            console.error('❌ Nessuna preference accettata');
        }
        
        return hasEmail && hasPreference;
    }

    // Funzione per controllare il messaggio di successo
    function checkSuccessMessage() {
        // Se già gestito, non fare nulla
        if (successHandled) {
            return;
        }

        const successMessage = document.querySelector('.message.success');
        
        if (successMessage) {
            const isVisible = window.getComputedStyle(successMessage).display === 'block' && 
                             successMessage.offsetParent !== null;
            
            if (isVisible) {
                console.log('Messaggio di successo visibile!');

                // Marca come gestito
                successHandled = true;
            }
        }
    }

    // Funzione per azioni personalizzate quando viene cliccato submit
    function handleSuccessActions() {
        // Aggiungi qui il tuo codice custom
        console.log('🚀 Button submit cliccato - esegui azioni personalizzate');
        console.log('Dati salvati disponibili:', formData);

        // Verifica che currentForm esista prima di usarlo
        if (!currentForm) {
            console.error('Form non trovato');
            return;
        }

        // Prepara i dati per Iubenda utilizzando i valori salvati
        const iubendaData = prepareIubendaData();
        
        // Invia i dati a Iubenda
        _iub.cons_instructions.push([
            "submit",
            {
                form: {
                    selector: currentForm
                },
                consent: {
                    // Specifica per quali documenti legali si sta dando il consenso
                    legal_notices: [
                        { identifier: "privacy_policy" },
                        { identifier: "cookie_policy" },
                        { identifier: "term" },
                    ],
                },
                // Usa i dati salvati
                ...iubendaData
            },
            {
                // Al successo, puoi eseguire azioni aggiuntive
                success: function(response) {
                    console.log("✅ Consenso Iubenda registrato con successo:", response);
                },
                // In caso di errore
                error: function(response) {
                    console.error("❌ Errore nella registrazione del consenso Iubenda:", response);
                    alert("Si è verificato un errore durante la registrazione del consenso. Riprova.");
                },
            },
        ]);
    }

    // Funzione per preparare i dati per Iubenda dai valori salvati
    function prepareIubendaData() {
        const iubendaData = {
            map: {
                subject: {},
                preferences: {}
            }
        };
        
        // Scorri i dati salvati e costruisci l'oggetto per Iubenda
        Object.keys(formData).forEach(function(key) {
            const field = formData[key];
            
            if (field.consSubject) {
                // Mappa i subject con il VALORE dell'input, non il nome del campo
                iubendaData.map.subject[field.consSubject] = field.value;
            }
            
            if (field.consPreference && field.value === true) {
                // Per le preferences, usa il nome del campo (corretto)
                iubendaData.map.preferences[field.consPreference] = field.name;
            }
        });
        
        console.log('Dati preparati per Iubenda:', iubendaData);
        return iubendaData;
    }

    // Observer per il messaggio di successo
    function observeSuccessMessage() {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    checkSuccessMessage();
                } else if (mutation.type === 'childList') {
                    // Controlla se è stato aggiunto un nuovo messaggio di successo
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) {
                            if (node.classList && node.classList.contains('success')) {
                                checkSuccessMessage();
                            }
                        }
                    });
                }
            });
        });

        // Osserva cambiamenti negli attributi style e nei nodi figlio
        const successElement = document.querySelector('.message.success');
        if (successElement) {
            observer.observe(successElement, {
                attributes: true,
                attributeFilter: ['style'],
                childList: true,
                subtree: true
            });
        }

        // Osserva anche il documento per nuovi messaggi di successo
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Esegui quando il DOM è caricato
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', processFormInputs);
    } else {
        processFormInputs();
    }

    // Observer per form caricati dinamicamente
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        // Controlla se il nodo aggiunto è un form o contiene form
                        if (node.tagName === 'FORM' || node.querySelector('form')) {
                            processFormInputs();
                        }
                    }
                });
            }
        });
    });

    // Avvia l'observer
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();